module.exports = __webpack_public_path__ + "static/media/sociana_logo.137bc354.webp";